import { render } from "./MinimumProfileGate.vue?vue&type=template&id=25ed323e"
import script from "./MinimumProfileGate.vue?vue&type=script&lang=js"
export * from "./MinimumProfileGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__